// constants

const SET_POP_UP = "SET_POP_UP";

// reducers

const initialState = {
	message: "",
	link: "",
	read: false,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_POP_UP:
			return {
				...state,
				...action.payload,
			};

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve("resolved");
//     }, 2000);
//   });
// };

// export const testCounterDecrement = () => async (dispatch) => {
//   const result = await resolveAfter2Seconds();
//   console.log(result);
//   dispatch({
//     type: TEST_COUNTER_DECREMENT,
//   });
// };

export const setPopUp = (popUp) => {
	return {
		type: SET_POP_UP,
		payload: { ...popUp },
	};
};
